// extracted by mini-css-extract-plugin
module.exports = {"PageContent":"PageContent--1nqEg","Headline":"Headline--3YTtR","Alert":"Alert--2Dc_f"};